import { ReactNode, useEffect } from "react";
import FocusLock from "react-focus-lock";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";

export interface DialogProps {
  header?: string;
  children: ReactNode;
  confirmText: string;
  cancelText?: string;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
}

export function Dialog(props: DialogProps) {
  const { t } = useTranslation();

  const button_close = t("button_close");

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape" && props.onClose) {
      props.onClose();
    }
    if (e.key === "Enter" && props.onConfirm) {
      props.onConfirm();
    }
    e.stopPropagation();
  };

  return (
    <FocusLock>
      <section role="dialog" aria-modal onKeyDown={handleKeyDown}>
        <div className="header">
          <h3>{props.header}</h3>
          <Button data-testid="dialog-close-button__testid" type="button" className="close" aria-label={button_close} onClick={props.onClose}>
            <i />
          </Button>
        </div>
        <div className="body">{props.children}</div>
        <div className="footer">
          {props.cancelText && props.onCancel && (
            <Button text={props.cancelText} data-testid="dialog-cancel-button__testid" variant="secondary" onClick={props.onCancel} />
          )}
          <Button text={props.confirmText} data-testid="dialog-confirm-button__testid" variant="primary" onClick={props.onConfirm} />
        </div>
      </section>
    </FocusLock>
  );
}

export default Dialog;
